import { render, staticRenderFns } from "./RegistrationConfirmationResendModal.vue?vue&type=template&id=583113fa"
import script from "./RegistrationConfirmationResendModal.vue?vue&type=script&lang=js"
export * from "./RegistrationConfirmationResendModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports